import React from "react";
import { Row, Col } from "antd";
import "./index.css";
import Button from "../../components/button/button";
import UserImg from "../../assets/images/user-img.png";
import { useHistory } from "react-router-dom";

const Home: React.FC = () => {
  let history = useHistory();

  const showWorks = () => {
    history.push("/works");
  };

  return (
    <div className="home_page">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={10} xl={12} className="cols_img">
          <img src={UserImg} alt="" className="user_img" />
        </Col>
        <Col xs={24} sm={24} md={24} lg={14} xl={12} className="cols">
          <h1>Hi, I’m Nweke Charles. </h1>
          <h4>Front-End Web Developer</h4>
          <p>
            I’m a Front-End Developer based in Abuja,
            Nigeria specialised in building exceptional, high-quality websites
            and applications. I’ve worked on various projects for leading
            agencies, startups and also handled contract based projects.
            Building state-of-the-art, easy to use, user-friendly websites and
            applications is truly a passion of mine as I love challenges when it
            comes to implementing a design. I take every project as a personal
            one visualising the proficiency of the use case and the logic
            involved. As a Front-End developer I have had the opportunities of
            learning how to use design tools and also working with backend
            engineers. These opportunities have made me more proficient in my
            line of work.
          </p>
          <Button label="My Works" handleClick={showWorks} />
        </Col>
      </Row>
    </div>
  );
};

export default Home;
